import React, { FunctionComponent } from 'react'
import { Text, IconVariantComponent } from '@afterpaytouch/core'
import styles from '../style.module.css'

interface PayMonthlyOnlyPointProps {
  headerText: string
  InformationIcon: IconVariantComponent
}

export const PayMonthlyOnlyPoint: FunctionComponent<PayMonthlyOnlyPointProps> = ({ headerText, InformationIcon }) => (
  <div className={styles.informationPoint}>
    <div className={styles.informationPointIcon}>
      <InformationIcon size='Medium' />
    </div>
    <div className={styles.informationPointText}>
      <Text size='XS'>{headerText}</Text>
    </div>
  </div>
)
